<template>
  <div class="index">
    <div class="top-img">
      <img src="../assets/top.png" alt="背景画像">
      <div class="logo">
        <img src="../assets/logo_white.png" alt="埜式">
      </div>
      <div class="top-h1">
        <h1>鎌倉を拠点とするIT企業</h1>
        <div class="catch">Webアプリケーション開発から、Web制作まで。開発業務を支援します。</div>
      </div>
    </div>
    <div class="specialty">
      <h2 class="ui header">得意分野</h2>
      <ul class="contents">
        <li class="content">
          <img src="../assets/development.jpg" alt="development image">
          <h3 class="ui header">WEB開発</h3>
          <p>課題の発見、解決案の提案、要件定義、設計、開発までをセットで実行することを得意としております。</p>
        </li>
        <li class="content">
          <img src="../assets/web.jpg" alt="web image">
          <h3 class="ui header">WEB制作</h3>
          <p>モバイルファーストなWEBサイトの制作をお受けしております。</p>
        </li>
        <li class="content">
          <img src="../assets/consulting.jpg" alt="consulting image">
          <h3 class="ui header">コンサルティング</h3>
          <p>開発に関する要件定義等のご相談等をお受けしております。</p>
        </li>
      </ul>
    </div>
    <div class="cta">
      <a href="/#/contact">
        <button class="positive ui huge button">お問い合わせはこちら</button>
      </a>
    </div>
    <div class="note">
      <h2 class="ui header">情報発信</h2>
      <div class="personal-note">
        <h3 class="ui header">代表社員 河埜のnote</h3>
        <ul>
          <li>
            <iframe class="note-embed" src="https://note.com/embed/notes/n425c4575be85" style="border: 0; display: block; max-width: 99%; width: 494px; padding: 0px; margin: 10px 0px; position: static; visibility: visible;" height="400"></iframe>
          </li>
          <!--<li>-->
            <!--<iframe class="note-embed" src="https://note.com/embed/notes/n27cccab38db6" style="border: 0; display: block; max-width: 99%; width: 494px; padding: 0px; margin: 10px 0px; position: static; visibility: visible;" height="400"></iframe>-->
          <!--</li>-->
        </ul>
      </div>
      <div class="passket-note">
        <h3 class="ui header">自社サービス：PASSKETの開発note</h3>
        <ul>
          <li>
            <iframe class="note-embed" src="https://note.com/embed/notes/n073083eacae3" style="border: 0; display: block; max-width: 99%; width: 494px; padding: 0px; margin: 10px 0px; position: static; visibility: visible;" height="400"></iframe>
          </li>
          <li>
            <iframe class="note-embed" src="https://note.com/embed/notes/n27cccab38db6" style="border: 0; display: block; max-width: 99%; width: 494px; padding: 0px; margin: 10px 0px; position: static; visibility: visible;" height="400"></iframe>
          </li>
        </ul>
      </div>
    </div>
    <div class="cta">
      <a href="/#/contact">
        <button class="positive ui huge button">お問い合わせはこちら</button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-family: "Noto Sans JP", メイリオ, Meiryo, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif;
    font-weight: 900;
  }
  .catch{
    font-size: 1.125rem;
    font-family: "Noto Sans JP", メイリオ, Meiryo, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif;
    font-weight: 900;
  }
  h3{
    color: black;
    font-size: 22px;
  }
  h4{
    color: black;
    font-size: 20px;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
  p{
    font-size: 16px;
    font-family: "Noto Sans JP", メイリオ, Meiryo, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif;
  }
  @media screen and (min-width: 601px) {
    .top-h1 {
      position: absolute;
      top: 380px;
      text-align: center;
      color: white;
      left: 0;
      right: 0;
    }

    .top-h1 h1 {
      font-size: 3.75rem;
    }

    .top-h1 h2 {
      font-size: 1.125rem;
    }

    .top-img img {
      width: 100%;
    }

    .logo {
      position: absolute;
      top: 140px;
      /* margin-leftはwidthの半分 */
      width: 200px;
      margin-left: -100px;
      left: 50%;
    }

    .specialty {
      color: black;
      margin: 75px 0;
    }

    .content {
      max-width: 350px;
      margin: 50px 30px;
    }

    .content img {
      width: 100%;
    }

    .cta {
      margin: 50px 0;
    }

    .note {
      margin: 70px 0 50px;
    }
  }
  @media screen and (max-width: 600px) {
    .top-img img {
      /*width: 100%;*/
      height: 400px;
      width: 100%;
    }
    .logo {
      position: absolute;
      top: 100px;
      /* margin-leftはwidthの半分 */
      margin-left: -75px;
      left: 50%;
    }
    .logo img{
      width: 150px;
      height: 150px;
    }
    .top-h1 {
      margin: 0 15px;
      position: absolute;
      top: 280px;
      text-align: center;
      color: white;
      left: 0;
      right: 0;
    }
    .top-h1 h1 {
      font-size: 26px;
    }

    .top-h1 h2 {
      font-size: 22px;
    }
    .specialty {
      color: black;
      margin: 75px 0;
    }
    .content {
      max-width: 350px;
      margin: 50px 30px;
    }
    .content img {
      width: 100%;
    }
    .cta {
      margin: 50px 0;
    }
    .note {
      margin: 70px 0 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue